module.exports = __webpack_public_path__ + "static/AvenirLTStd-Book-2e8ade048f42c231d5f5e694190c55e5.woff";